/**
 * User Setting Category
 * Flutter source: lib/domain/enums/user_setting_category.dart
 *
 * Maps to the `category` field in UserSettingDto/UserSettingStorage.
 */
export enum UserSettingCategory {
  content = 0,
  notifications = 1,
  privacy = 2,
  qa = 3,
  payment = 4,
}
